import type { ShiftHistoryTimelineEvent, ShiftHistoryTrail } from '../../../types/shiftHistory'

export const validShiftHistoryPoint = (latitude: unknown, longitude: unknown) => {
  const lat = Number(latitude)
  const lon = Number(longitude)
  return Number.isFinite(lat) && Number.isFinite(lon) && lat >= -90 && lat <= 90 && lon >= -180 && lon <= 180
}

export const orderedShiftHistoryTimeline = (events: ShiftHistoryTimelineEvent[]) =>
  [...events].sort((left, right) => Date.parse(left.occurredAt) - Date.parse(right.occurredAt))

export const hasRecordedShiftTrail = (trail?: ShiftHistoryTrail | null) =>
  Boolean(trail?.segments.some((segment) => segment.points.some((point) => validShiftHistoryPoint(point.latitude, point.longitude))))
